export const PLATFORM_META = {
  facebook:  { name: "Facebook",    icon: "fa-brands fa-facebook-f",  color: "#1877F2" },
  instagram: { name: "Instagram",   icon: "fa-brands fa-instagram",   color: "#E4405F" },
  linkedin:  { name: "LinkedIn",    icon: "fa-brands fa-linkedin-in", color: "#0A66C2" },
  x:         { name: "X (Twitter)", icon: "fa-brands fa-x-twitter",   color: "#111111" },
};

export const fmt = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n ?? 0}`);
